<template>
    <div>
        <!-- 顶部 -->
        <el-row>
            <el-col :span='24'>
                <el-form :inline='true'>
                    <el-form-item label='关键字：'>
                        <el-input v-model.trim='filters.keyWord' placeholder='请输入姓名/手机号/身份证号' clearable @clear='getData' @input='() => (filters.keyWord = filters.keyWord.replace(/\s/g,""))' @keyup.enter.native='getData'></el-input>
                    </el-form-item>
                    <el-form-item>
                        <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <!-- 列表 -->
        <el-table
        border
        v-loading='listLoading'
        :data="tableData"
        highlight-current-row
        style="width: 100%">
            <el-table-column type="index" width="55" label='序号' align='center' show-overflow-tooltip></el-table-column>
            <el-table-column prop="Name" width="" label='姓名' align='center' show-overflow-tooltip></el-table-column>
            <el-table-column prop="Gender" width="" label='性别' align='center'>
                <template slot-scope='scope'>
                    <el-tag :type='scope.row.Gender == 0?"success":"primary"'>{{scope.row.Gender == 0 ? "女" : "男"}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="Phone" width="" label='手机号' align='center' show-overflow-tooltip></el-table-column>
            <el-table-column prop="CardNo" width="130" label='身份证号码' align='center' show-overflow-tooltip></el-table-column>
            <el-table-column prop="UnitName" width="130" label='社会单位名称' align='center' show-overflow-tooltip></el-table-column>
            <el-table-column prop="Province" width="" label='省份' align='center'></el-table-column>
            <el-table-column prop="City" width="" label='城市' align='center'></el-table-column>
            <el-table-column prop="Region" width="" label='区县' align='center'></el-table-column>
            <el-table-column prop="RequestSource" width="100" label='数据来源' align='center' ></el-table-column>
            <el-table-column prop="Address" width="120" label='单位地址' align='center' show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop="TradeName" width="120" label='行业名称' align='center' show-overflow-tooltip></el-table-column> -->
            <el-table-column prop="StationName" width="120" label='岗位名称' align='center' show-overflow-tooltip></el-table-column>
            <el-table-column prop="AgencyName" width="120" label='培训机构名称' align='center' show-overflow-tooltip></el-table-column>
            <el-table-column prop="HeadPhotoUrl" width="" label='证件照' align='center'>
                <template slot-scope='scope'>
                    <el-popover placement='right' trigger='hover'>
                        <img :src="scope.row.HeadPhotoUrl" alt="" style='width:120px;height:150px'> 
                        <img slot="reference" :src="scope.row.HeadPhotoUrl" alt="" style='width: auto;height: auto;max-width: 30px;max-height: 30px;'>                   
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="CreateUserID" width="" label='创建人' align='center'></el-table-column>
            <el-table-column prop="CreateTime" width="130" label='创建时间' align='center' :formatter="formatCreateTime" show-overflow-tooltip></el-table-column>
            <el-table-column prop="RelatedStudentExamineeAccounts" width="100" label='关联账号' align='center' show-overflow-tooltip></el-table-column>
            <el-table-column prop="IsEnable" width="" label='启用标识' align='center' fixed="right">
                <template slot-scope='scope'>
                    <el-tag :type='scope.row.IsEnable?"success":"primary"'>{{scope.row.IsEnable?'启用':'禁用'}}</el-tag>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount">
        </el-pagination>
    </div>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import util from "../../../util/date";
import {getStudentLearningIdentityListPage} from '@/api/api'
export default {
    components: { Toolbar },
    data(){
        return {
            buttonList: [],
            filters:{
                keyWord:''
            },
            listLoading:false,
            tableData:[],
            pages:{
                pageIndex:1,
                pageSize:20,
                dataCount:0
            }
        }
    },
    methods:{
        callFunction(item) {
            this[item.Func].apply(this, item);
        },
        formatCreateTime: function(row, column) {
            return !row.CreateTime || row.CreateTime == ""
            ? ""
            : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd hh:mm:ss");
        },
        // 查询
        getStudentLearningIdentityListPage() {
            this.pages.pageIndex = 1
            this.getData()
        },
        // 获取列表数据
        getData(){
            var params = {
                keyWord:this.filters.keyWord,
                pageIndex:this.pages.pageIndex,
                pageSize:this.pages.pageSize
            }
            this.listLoading = true
            getStudentLearningIdentityListPage(params).then(res => {
                this.listLoading = false
                if(res.data.Success){
                    this.tableData = res.data.Response.Data
                    this.pages.dataCount = res.data.Response.DataCount
                }else{
                    this.$message.error(res.data.Message)
                }
            }).catch(() => {
                this.listLoading = false
                this.$message.error(res.data.Message)
            })
        },
        // 分页
        handleSizeChange(value){
            this.pages.pageSize = value
            this.getData()
        },
        handleCurrentChange(value){
            window.sessionStorage.setItem('pagination',JSON.stringify(value))
            this.pages.pageIndex = value
            this.getData()
        }
    },
    beforeRouteEnter(to,from,next){
        if(from.path.indexOf(to.path) == -1){
            window.sessionStorage.removeItem('pagination')
        }
        next()
    },
    created(){
        this.pages.pageIndex = Number(window.sessionStorage.getItem('pagination')) || 1
        this.getData()
    },
    mounted(){
        let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
        this.buttonList = getButtonList(this.$route.path, routers);
    }
}
</script>

<style lang="stylus" scoped>

</style>
<style>
    .el-tooltip__popper {
        max-width: 500px;
    }
</style>